<div class="outer-box">
  <img class="progress-bar-mascot" src="assets/images/robot.png" alt="" />
  <cygov-progress-bar class="progress-bar" [assessmentLevel]="progress" [postFill]="postFill"
    [preFill]="preFill" [height]="15">
  </cygov-progress-bar>
</div>
